import { signOut } from 'aws-amplify/auth';
import { createContext, useContext } from 'react';

export interface AppUser {
    email: string;
    userId: string;
    groups: string[];
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const createAppUser = (cognitoUser: any): AppUser => {
    return {
        userId: cognitoUser.sub,
        email: cognitoUser.email,
        groups: cognitoUser.groups,
    };
};

export const AuthContext = createContext<AppUser | null>(null);

export const useAuth = () => {
    const user = useContext(AuthContext) as AppUser;

    const logout = () => {
        signOut();
    };

    return { user, logout };
};
